import { gql } from 'apollo-angular';

export const GET_OFFERS_AUDIT_DATA = gql`
  query GetOffersAudit($criteria: OfferCriteria!) {
    offers(criteria: $criteria) {
      id
      rfpId
      name
      unorderedPricing
      unorderedTiers
      auditInfo {
        createdBy
        createdDate
        lastModifiedBy
        lastModifiedDate
      }
      attachments {
        legacyAttachments
        attachments {
          fileName
          fileId
        }
      }
    }
  }
`;
